import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiCheckbox from '@material-ui/core/Checkbox';

import { useStyles } from './styles';
import useUpdateFilterValue from '../../../hooks/useUpdateFilterValue';
import { useSelector } from 'react-redux';
import PartCountLabel from '../PartCountLabel/PartCountLabel';

const Checkbox = ({
	gutterVertical,
	name,
	size,
	disableRipple,
	appliedValue,
	updateAppliedValue,
	disabled,
	label,
	cid,
	categoryId,
	...rest
}) => {
	const classes = useStyles({ gutterVertical });
	const { t } = useTranslation();

	const { updateFilterValue } = useUpdateFilterValue();
	const countOfPartsForFilterOptions = useSelector(state => state.filters.countOfPartsForFilterOptions || {});

	const handleCheck = event => {
		if (cid) {
			updateFilterValue(cid, categoryId, event.target.checked ? true : null);
		} else {
			updateAppliedValue(event.target.checked ? true : null);
		}
	};

	const partCountExist = countOfPartsForFilterOptions[cid] && countOfPartsForFilterOptions[cid]['true'];
	const count = partCountExist ? countOfPartsForFilterOptions[cid]['true'].count : 0;
	const displayLabel = (
		<>
			{typeof label === 'string' ? (i18next.exists(`filterValue.${label}`) ? t(`filterValue.${label}`) : label) : label}
			{partCountExist && <PartCountLabel count={count} />}
		</>
	);
	const isSelected = appliedValue;
	const disableByPartcount = partCountExist && count === 0;

	return (
		<FormControlLabel
			classes={{
				root: classes.formControlLabelRoot,
				label: classes.formControlLabelLabel
			}}
			control={
				<MuiCheckbox
					color="primary"
					name={name || undefined}
					size={size || 'medium'}
					disableRipple={disableRipple || false}
					disabled={!isSelected && (disabled || disableByPartcount)}
					checked={appliedValue}
					onClick={handleCheck}
					{...rest}
					classes={{ root: classes.checkboxRoot }}
				/>
			}
			label={displayLabel}
		/>
	);
};

Checkbox.propTypes = {
	gutterVertical: PropTypes.bool,
	name: PropTypes.string,
	size: PropTypes.string,
	disableRipple: PropTypes.bool,
	appliedValue: PropTypes.arrayOf(PropTypes.string).isRequired,
	updateAppliedValue: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired,
	label: PropTypes.string
};

export default React.memo(Checkbox);
